import { Component, Input, ViewChild } from '@angular/core';
import { AvailableQuestion, SecretQuestion } from '@models/two-fa.models';

@Component({
	selector: 'question-item',
	template: require('./question-item.component.html'),
	styles: [require('./question-item.component.scss')]
})
export class QuestionItemComponent {
	@ViewChild('select') select;
	@Input() index: number;
	@Input() field: SecretQuestion;
	@Input() availableQuestions: Array<AvailableQuestion>;
	selectedAnswer: string;

	changeQuestion(event): void {
		if (this.field.question) {
			this.changeQuestionSelectedState(this.field.question, false);
		}

		if (event.target.value === 'null') {
			this.field.question = null;
			this.field.answer = '';
			this.selectedAnswer = null;
			return;
		}

		this.changeQuestionSelectedState(event.target.value, true);
		this.field.question = event.target.value;
	}

	private changeQuestionSelectedState(question: string, state: boolean): void {
		this.availableQuestions.forEach((questionItem: AvailableQuestion): void => {
			if (questionItem.question === question) {
				questionItem.selected = state;
				this.selectedAnswer = questionItem.question;
			}
		});
	}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/string-replace-webpack-plugin/loader.js?id=oom9nsliule!./web/modern/components/2fa/modals/two-fa-setup-modal/set-up-questions/question-item/question-item.component.ts